import { useState } from "react";
import { Diagram } from "./Diagram";
import { SortControl } from "./SortControl";
import { ZoomControl } from "./ZoomControl";
import { CategoryControl } from "./CategoryControl";
import { Tooltip } from "./Tooltip";
import { PoweredBy } from "./PoweredBy";
import { AnimatePresence, useMotionValue } from "framer-motion";
import { useLayoutEffect } from "react";
const sortOptions = [
	{ label: "Category", key: "category" },
	{ label: "Alphabetical", key: "alphabetical" },
	{ label: "Score (High - Low)", key: "score" },
];

export function TechRadar({ modalOpen, activeCategory }) {
	const [zoomLevel, setZoomLevel] = useState(1);
	const [sort, setSort] = useState(sortOptions[0]);
	const [hoveredCategory, setHoveredCategory] = useState(activeCategory);
	const [hoveredItem, setHoveredItem] = useState({});
	const [hoveredItemMousePos, setHoveredItemMousePos] = useState();
	// const [draggingMousePos, setDraggingMousePos] = useState({});
	const draggingMousePos = useMotionValue({});
	const mousePosition = useMotionValue({ x: 0, y: 0 });

	useLayoutEffect(() => {
		let cb = (e) => {
			mousePosition.set({ x: e.clientX, y: e.clientY });
		};
		window.addEventListener("mousemove", cb);
		return () => {
			window.removeEventListener("mousemove", cb);
		};
	}, [mousePosition]);

	const minScale = 0.5;
	const maxScale = 3;

	const delay1 = 0.2;
	const delay2 = 0.7;
	const delay3 = 1.2;
	const durationUI = 2;

	return (
		<div>
			<Diagram
				zoomLevel={zoomLevel}
				setZoomLevel={setZoomLevel}
				minScale={minScale}
				maxScale={maxScale}
				sort={sort.key}
				hoveredCategory={hoveredCategory}
				hoveredItem={hoveredItem}
				setHoveredItem={setHoveredItem}
				setHoveredItemMousePos={setHoveredItemMousePos}
				draggingMousePos={draggingMousePos}
				modalOpen={modalOpen}
				delay1={delay1}
				delay2={delay2}
				delay3={delay3}
			/>
			<AnimatePresence exitBeforeEnter={true}>
				{hoveredItem.title ? (
					<Tooltip
						{...hoveredItem}
						key={hoveredItem.title}
						item={hoveredItem}
						initialMousePos={hoveredItemMousePos}
						draggingMousePos={draggingMousePos}
						modalOpen={modalOpen}
						mousePosition={mousePosition}
					/>
				) : null}
			</AnimatePresence>
			<ZoomControl
				value={zoomLevel}
				setValue={setZoomLevel}
				minScale={minScale}
				maxScale={maxScale}
				modalOpen={modalOpen}
				delay={delay3}
				duration={durationUI}
			/>
			<SortControl
				updateSort={setSort}
				sort={sort}
				sortOptions={sortOptions}
				modalOpen={modalOpen}
				delay={delay3}
				duration={durationUI}
			/>
			<CategoryControl
				setHoveredCategory={setHoveredCategory}
				activeCategory={activeCategory}
				delay={delay3}
				duration={durationUI}
				modalOpen={modalOpen}
			/>
			<PoweredBy modalOpen={modalOpen} delay={delay3} duration={durationUI} />
		</div>
	);
}
